import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError, finalize} from 'rxjs/operators';
import { ProgressBarService } from '../../service/progress-bar.service';

@Injectable()
export class HttpInterceptorService implements HttpInterceptor {

  constructor(private progressBarService: ProgressBarService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.progressBarService.show();
    return next.handle(request).pipe(
      finalize(() => this.progressBarService.hide())
    );
  }
}
